<template>
  <div>
    <div class="form-container">
      <ProgressBar :progressPercent="60" progressLabel="Step 3 of 5" />
      <h1 class="step-title">Underwriting</h1>
      <div class="row">
        <div class="col-md-4 mb-3">
          <label for="applicant_type">Type of Risk</label>
          <select
            id="applicant_type"
            class="form-control  shadow-none select"
            :value="three.applicant_type"
            @input="updateField('applicant_type', $event.target.value)"
          >
            <option value="Owner">Owner</option>
            <option value="Renter">Renter</option>
            <option value="Landlord">Landlord</option>
          </select>
          <div class="e-wrapper">
            <p v-if="!$v.three.applicant_type.required" class="small required">
              * Required
            </p>
          </div>
        </div>
        <div class="col-md-4 mb-3">
          <label for="property_type">Type of Property</label>
          <select
            id="property_type"
            class="form-control  shadow-none select"
            :value="three.property_type"
            @input="updateField('property_type', $event.target.value)"
          >
            <option value="Dwelling">Dwelling</option>
            <option value="Condo">Condo</option>
          </select>
          <div class="e-wrapper">
            <p v-if="!$v.three.property_type.required" class="small required">
              * Required
            </p>
          </div>
        </div>
        <div class="col-md-4 mb-3">
          <label for="property_use">Use of Property</label>
          <select
            id="property_use"
            class="form-control  shadow-none select"
            :value="three.property_use"
            @input="updateField('property_use', $event.target.value)"
          >
            <option value="Primary Residence">Primary Residence</option>
            <option value="Vacation Use">Vacation Use</option>
          </select>
          <div class="e-wrapper">
            <p v-if="!$v.three.property_use.required" class="small required">
              * Required
            </p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <label for="underground_floors">Underground Floors</label>
          <select
            id="underground_floors"
            class="form-control shadow-none select"
            :value="three.underground_floors"
            @input="updateField('underground_floors', $event.target.value)"
          >
            <option value="No">No</option>
            <option value="Yes">Yes</option>
          </select>
          <div class="e-wrapper">
            <p
              v-if="!$v.three.underground_floors.required"
              class="small required"
            >
              * Required
            </p>
          </div>
        </div>
        <div class="col-md-4 mb-3">
          <label for="roof_type">Roof Type</label>
          <select
            id="roof_type"
            class="form-control shadow-none select"
            :value="three.roof_type"
            @input="updateField('roof_type', $event.target.value)"
          >
            <option value="Concrete">Concrete</option>
            <option value="Wood">Wood</option>
          </select>
          <div class="e-wrapper">
            <p v-if="!$v.three.roof_type.required" class="small required">
              * Required
            </p>
          </div>
        </div>
        <div class="col-md-4 mb-3">
          <label for="wall_type">Main Dwelling</label>
          <select
            id="wall_type"
            class="form-control shadow-none select"
            :value="three.wall_type"
            @input="updateField('wall_type', $event.target.value)"
          >
            <option value="Concrete">Concrete</option>
            <option value="Wood">Wood</option>
          </select>
          <div class="e-wrapper">
            <p v-if="!$v.three.wall_type.required" class="small required">
              * Required
            </p>
          </div>
        </div>
      </div>

      <div class="shutter__row">
        <div class="col-md-4 shutter__select">
          <label for="storm_shutters">Storm Shutters</label>
          <select
            id="storm_shutters"
            class="form-control shadow-none select"
            :value="three.storm_shutters"
            @input="updateField('storm_shutters', $event.target.value)"
          >
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
          <div class="e-wrapper">
            <p v-if="!$v.three.storm_shutters.required" class="small required">
              * Required
            </p>
          </div>
        </div>
        <div v-if="three.storm_shutters === 'Yes'" class="col-md-8">
          <div class="small">
            Are the Window Storm Shutters Category 5 Dade County Florida
            approved certified for HVHZ (High Velocity Hurricane Zone) Storm
            Shutters?
          </div>
          <div class="radio-inline">
            <label>
              <input
                type="radio"
                @input="updateField('storm_shutters_hurricane', true)"
                :checked="three.storm_shutters_hurricane"
              />
              Yes
            </label>
          </div>
          <div class="radio-inline">
            <label>
              <input
                type="radio"
                @input="updateField('storm_shutters_hurricane', false)"
                :checked="!three.storm_shutters_hurricane"
              />
              No
            </label>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <label for="adjacent_structures">Structures</label>
          <select
            id="adjacent_structures"
            class="form-control shadow-none select"
            :value="three.adjacent_structures"
            @input="updateField('adjacent_structures', $event.target.value)"
          >
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
          <div class="e-wrapper">
            <p
              v-if="!$v.three.adjacent_structures.required"
              class="small required"
            >
              * Required
            </p>
          </div>
          <p class="small">Adjacent Structures to your home</p>
        </div>
        <div class="col-md-4">
          <label for="number_of_stories">Number of Stories</label>
          <select
            id="number_of_stories"
            class="form-control shadow-none select"
            :value="three.number_of_stories"
            @input="updateField('number_of_stories', $event.target.value)"
          >
            <option value="1 Story">1</option>
            <option value="2 Stories">2</option>
            <option value="3 Stories">3</option>
          </select>
          <div class="e-wrapper">
            <p
              v-if="!$v.three.number_of_stories.required"
              class="small required"
            >
              * Required
            </p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <label for="distance_from_coast">Distance from Coast Line</label>
          <select
            id="distance_from_coast"
            class="form-control shadow-none select"
            :value="three.distance_from_coastline"
            @input="updateField('distance_from_coastline', $event.target.value)"
          >
            <option value="More than 500 Meters">More than 500 Meters</option>
            <option value="Less than 500 Meters">Less than 500 Meters</option>
          </select>
          <div class="e-wrapper">
            <p
              v-if="!$v.three.distance_from_coastline.required"
              class="small required"
            >
              * Required
            </p>
          </div>
        </div>
        <div class="col-md-6">
          <label for="distance_above_sea">Distance above Sea Level</label>
          <input
            type="text"
            id="distance_above_sea"
            class="form-control shadow-none select"
            :value="three.distance_above_sea"
            @input="updateField('distance_above_sea', $event.target.value)"
            placeholder="Distance above sea - in Meters"
          />
          <div class="e-wrapper">
            <p
              v-if="!$v.three.distance_above_sea.required"
              class="small required"
            >
              * Required
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="step-buttons">
      <button class="btn btn-primary" type="button" @click.prevent="prev()">
        Previous
      </button>
      <button class="btn btn-primary" type="button" @click.prevent="next()">
        Next
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { required } from "vuelidate/lib/validators";
import ProgressBar from "./ProgressBar";

export default {
  components: { ProgressBar },
  computed: {
    ...mapState(["three"]),
  },
  validations: {
    three: {
      applicant_type: {
        required,
      },
      property_type: {
        required,
      },
      property_use: {
        required,
      },
      roof_type: {
        required,
      },
      wall_type: {
        required,
      },
      storm_shutters: {
        required,
      },
      underground_floors: {
        required,
      },
      adjacent_structures: {
        required,
      },
      number_of_stories: {
        required,
      },
      distance_from_coastline: {
        required,
      },
      distance_above_sea: {
        required,
      },
    },
  },
  methods: {
    ...mapActions(["updateFormThree", "nextStep", "prevStep"]),
    updateField(key, val) {
      const updates = { [key]: val };
      this.updateFormThree(updates);
    },
    prev() {
      window.scrollTo(0, 0);
      this.prevStep();
    },
    next() {
      window.scrollTo(0, 0);
      if (this.$v.$invalid) {
        return;
      } else {
        this.nextStep();
      }
    },
  },
};
</script>

<style>
.shutter__row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  /* match margins with bootstrap row */
  margin-left: -15px;
  margin-right: -15px;
}
@media (max-width: 992px) {
  .shutter__select {
    width: 100%;
  }
}
</style>
